import SgpButton from './button.vue'

SgpButton.install = function (Vue) {
  Vue.component(SgpButton.name, SgpButton)
}

if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use(SgpButton)
}

export default SgpButton
